import { BillOfMaterialUpdatePage } from '@/features/bill-of-material/pages/BillOfMaterialUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/bill-of-material/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["bill_of_material.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BillOfMaterialUpdatePage,
})
